import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../../shared/services/api.service';
import { AppSettings, Settings } from '../../app.settings';
import { SharedDataService } from 'src/app/shared/services/sharedata.service';
@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  public settings: Settings;
  public themeType: any;

  constructor(private http: HttpClient, private apiService: ApiService, private appSettings: AppSettings, private shareData: SharedDataService) {
    this.settings = this.appSettings.settings;
  }



  loadAppConfig(): Promise<any> {
    return this.apiService
      .getStoreDetails()
      .toPromise()
      .then((data: any) => {
        if (data['response']['status'] === 1) {
          const storeJson = data['response']['data']['store_json'];
          this.themeType = storeJson['settings']['main-theme'] || 'Default';
          this.settings['gaTrackingID'] = storeJson['settings']['analytic-js-tracking-id'];
          this.settings['gaTrackingShow'] = storeJson['settings']['analytic-js'];
          this.settings['themeType'] = storeJson['settings']['main-theme'] || 'Default';
          // Save theme type in sessionStorage
          sessionStorage.setItem('store-theme', this.themeType);

          // Return the necessary configuration data
          return {
            themeType: this.themeType
          };
        }
        // Return null or undefined if data is not valid
        return null;
      })
      .catch((error) => {
        console.error('Error loading store details:', error);
        return null; // Return null in case of error
      });
  }

  async loadModule(): Promise<{ path: string, name: string } | null> {
    switch (this.themeType) {
      case 'Hudson':
        return { path: './main-theme/hudson/hudson.module', name: 'HudsonPagesModule' };
      case 'Olivor':
        return { path: './main-theme/olivor/olivor.module', name: 'OlivorPagesModule' };
      case 'grison-dairy':
      case 'woodview':
        return { path: './main-theme/grison-dairy/grisondairy.module', name: 'GrisonDairyModule' };
      case 'little-farm':
      return { path: './main-theme/little-farm/littlefarm.module', name: 'LittleFarmPagesModule' };
      default:
        return { path: './main-theme/global-theme/pages/pages.module', name: 'PagesModule' };
    }
  }










  // loadAppConfig() {
  //   return this.apiService
  //     .getStoreDetails()
  //     .toPromise()
  //     .then((data: any) => {
  //       if (data['response']['status'] === 1) {
  //         this.themeType = data['response']['data']['store_json']['settings']['main-theme'] || 'Default';
  //         this.settings['gaTrackingID'] = data['response']['data']['store_json']['settings']['analytic-js-tracking-id'];
  //         this.settings['gaTrackingShow'] = data['response']['data']['store_json']['settings']['analytic-js'];
  //         this.loadcomponentService.themeType = this.themeType
  //         sessionStorage.setItem('store-theme', this.themeType);
  //       }
  //     });
  // }

}